import { usePWAInstall } from '../hooks/usePWAInstall';
import { useT } from '../i18n';
import { type NavView } from './Layout';

interface InstallFloatButtonProps {
  onNavigate?: (view: NavView) => void;
}

/**
 * Botão flutuante de instalação PWA.
 * Posicionado no canto inferior direito (posição FAB padrão — Issue #549:
 * antes ficava no topo e cobria o header/conteúdo em telas estreitas).
 * - Se canInstall: dispara beforeinstallprompt ao clicar
 * - Se isInstalled: oculto
 * - Se sem suporte: navega para /install
 */
export function InstallFloatButton({ onNavigate }: InstallFloatButtonProps) {
  const t = useT();
  const { canInstall, isInstalled, promptInstall } = usePWAInstall();

  if (isInstalled) return null;

  const handleClick = () => {
    if (canInstall) {
      promptInstall();
    } else {
      onNavigate?.('install');
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      title={canInstall ? t('install.button') : t('install.help_button')}
      aria-label={canInstall ? t('install.button') : t('install.help_button')}
      className="fixed bottom-6 right-6 z-50 transition-transform hover:scale-110 active:scale-95"
      style={{
        width: '56px',
        height: '56px',
        backgroundImage: 'url(/icons/install-float.png)',
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        border: 'none',
        cursor: 'pointer',
        filter: 'drop-shadow(0 4px 6px rgba(0,0,0,0.2))',
      }}
    />
  );
}

export default InstallFloatButton;
